import React, {useState} from 'react';
import CKEditor from "../CKEditor/CKEditor";
import {PromptDialog} from "../Dialog/Message";

export const TemplateTextContent = ({toggleModal, content, buttonComp, displayEditContentButton, activeTemplate, publishActiveTemplate, canCustomize}) => {
  const CKEditorCustomProps = {
    content,
    activeTemplate,
    form: {
      canEditContent: false
    }
  }
  const [show, setShow] = useState(false);
  return (
    <div className='editor_wrap'>
      <CKEditor {...CKEditorCustomProps} />
      <div className="cta">
        {/*<button className="btn btn-primary">Get Started</button>*/}
        {!canCustomize && buttonComp}
        {canCustomize && <button className="btn btn-primary" onClick={() => setShow(true)}>Publish Template</button>}
        {displayEditContentButton &&
          <button className="btn btn-primary"  onClick={toggleModal} style={{'zIndex':'99'}} >Customize Template</button>
        }
      </div>
      {
        show &&
        <PromptDialog
          onRef={(ref) => {
          }}
          onlyDialog={true}
          title={"Publish Template"}
          body={"The published template will be displayed to all prospects who click on your unique 9 to Know Link."}
          okText={"Yes"}
          cancelText={"No"}
          onOk={() => {publishActiveTemplate(); setShow(false);}}
          onCancel={() => setShow(false)}
          show={show}
        />
      }
    </div>
  )
}
